import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { PageHeader } from '../components/PageHeader';
import { Users, Phone, Star, ChevronRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function PartnersPage() {
    const [partners, setPartners] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchPartners();
    }, []);

    const fetchPartners = async () => {
        try {
            const response = await axios.get(`${API}/partners`);
            // Sort featured first
            const sorted = response.data.sort((a, b) => (b.featured ? 1 : 0) - (a.featured ? 1 : 0));
            setPartners(sorted);
        } catch (error) {
            console.error('Error fetching partners:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-container" data-testid="partners-page">
            <PageHeader title="Local Partners" showBack />
            
            <div className="px-4 py-4">
                {/* Header */}
                <div className="card-base bg-primary/5 mb-6">
                    <div className="flex items-center gap-3">
                        <Users className="w-8 h-8 text-primary" />
                        <div>
                            <h2 className="font-bold text-foreground">Trusted Local Businesses</h2>
                            <p className="text-muted-foreground text-sm">Recommended by Burston Garden Centre</p>
                        </div>
                    </div>
                </div>

                {loading ? (
                    <div className="flex justify-center items-center py-12">
                        <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
                    </div>
                ) : (
                    <div className="space-y-4" data-testid="partners-list">
                        {partners.length === 0 ? (
                            <div className="card-base text-center py-8">
                                <p className="text-muted-foreground">No partners listed at the moment.</p>
                            </div>
                        ) : (
                            partners.map(partner => (
                                <div 
                                    key={partner.id} 
                                    className={`card-base ${partner.featured ? 'border-2 border-accent/30' : ''}`}
                                    data-testid={`partner-card-${partner.id}`}
                                >
                                    {partner.featured && (
                                        <div className="flex items-center gap-1 text-accent mb-3">
                                            <Star className="w-4 h-4 fill-current" />
                                            <span className="text-sm font-bold">Featured Partner</span>
                                        </div>
                                    )}
                                    <div className="flex items-start justify-between gap-4">
                                        <div className="flex-1">
                                            <span className="inline-block px-3 py-1 rounded-full text-sm font-medium bg-primary/10 text-primary mb-2">
                                                {partner.category}
                                            </span>
                                            <h3 className="text-lg font-bold text-foreground">{partner.name}</h3>
                                            <p className="text-muted-foreground mt-1">{partner.description}</p>
                                            {partner.contact_info && (
                                                <div className="flex items-center gap-2 mt-3 text-primary">
                                                    <Phone className="w-4 h-4" />
                                                    <span className="font-medium">{partner.contact_info}</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                )}

                {/* CTA */}
                <div className="mt-8 card-base bg-secondary text-white text-center">
                    <h3 className="font-bold text-lg mb-2">Want to appear here?</h3>
                    <p className="text-white/80">Ask about our partner programme at Customer Service</p>
                </div>
            </div>
        </div>
    );
}

export default PartnersPage;
